import ListVM from './list-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    var data = JSON.parse(node.dataset.coursesData);
    var type = node.dataset.courseType;

    const vm = new Vue(ListVM);
    vm.initializeBindData(data, type);
    vm.$mount(node);

    Kadenze.Share.init();
  }
};
